import { type ReactNode, useState } from 'react';

import Button, { type ButtonProps } from '../Button';
import { CheckMarkIcon, CopyIcon } from '../../icons';
import OverlayTriggerTooltip from '../OverlayTriggerTooltip';

import styles from './_index.module.scss';

export interface CopyToClipboardProps extends ButtonProps {
  finalContent?: ReactNode;
  finalTooltipText?: string;
  initialContent?: ReactNode;
  initialTooltipText?: string;
  value: string;
}

const CopyToClipboard = ({
  'data-testid': dataTestId = 'copy-to-clipboard',
  finalContent = <CheckMarkIcon />,
  finalTooltipText = '',
  initialContent = <CopyIcon />,
  initialTooltipText = 'Copy to clipboard',
  isDisabled = false,
  text = '',
  value,
  ...props
}: CopyToClipboardProps) => {
  const [isCopiedToClipboard, setIsCopiedToClipboard] = useState(false);

  const handleClick = () => {
    setIsCopiedToClipboard(true);
    navigator.clipboard.writeText(value);
    setTimeout(() => setIsCopiedToClipboard(false), 2000);
  };

  const InitialContent = initialContent;
  const FinalContent = finalContent;
  return (
    <OverlayTriggerTooltip content={isCopiedToClipboard ? finalTooltipText : initialTooltipText}>
      <Button
        aria-label={text ? undefined : props['aria-label'] || 'Copy to clipboard'}
        className={styles['copy-to-clipboard']}
        data-testid={dataTestId}
        icon={isCopiedToClipboard ? FinalContent : InitialContent}
        isDisabled={isDisabled || isCopiedToClipboard}
        onClick={handleClick}
        text={text}
        variant="secondary"
        {...props}
      />
    </OverlayTriggerTooltip>
  );
};

export default CopyToClipboard;
